import {svgIconWrapper} from '../svg-icon-wrapper';

import CallrailRegular from './callrail-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <CallrailRegular {...props} />;
}

SvgComponent.iconName = 'callrailRegular';

export const CallrailRegularIcon = svgIconWrapper(SvgComponent);
